import LawyerSignupPage from '@/pages/LawyerSignupPage'

export default {
    path: '/lawyer-signup',
    component: LawyerSignupPage,
}